<div class="header">
    <h2>
        <i class="zmdi zmdi-alarm"></i> Pacientes no reevaluados
    </h2>
</div>
<div class="body">
    <button *ngFor="let patient of notReevaluatedPatients" (click)="patientDetail(patient._id)" type="button" class="btn btn-raised btn-default waves-effect btn-block">{{ patient.user.names }} {{ patient.user.surnames }}</button>
</div>
